import styled, { css } from 'styled-components';
import { Box, FlexiPagination, Button } from '@flexisaf/flexibull2';

const LinedBox = styled(Box)`
  border: 1px solid ${(props) => props.theme.PrimaryBorderColor};
  margin-top: -1px;
  margin-right: -1px;
  padding: 10px;
  text-transform: capitalize;

  ${(props) =>
    props.header &&
    css`
      display: grid;
      grid-templates-columns: max-content auto;
      align-items: center;
      background: rgba(0, 0, 0, 0.03);
    `}

  & i.saf-dot-3 {
    display: inline-flex;
    width: 30px;
    height: 28px;
    border-radius: 3px;
    background: silver;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 1px solid ${(props) => props.theme.PrimaryBorderColor};
    transition: ${(props) => props.theme.PrimaryTransition};
    cursor: pointer;
    &:hover {
      color: ${(props) => props.theme.PrimaryGreyDark};
      border: 1px solid ${(props) => props.theme.PrimaryGrey};
      background: ${(props) => props.theme.PrimaryGreyMid};
    }
  }
`;

export default LinedBox;

export const TransBox = styled(Box)`
  & .flexi-table {
    overflow-x: auto !important;
  }
`;

export const EditedPagination = styled(FlexiPagination)`
  @media (max-width: 700px) {
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 70px !important;
  }
  & .rc-pagination-total-text {
    @media (max-width: 1050px) {
      display: none;
    }
  }
`;
export const Boxcolumn = styled(Box)`
  @media (max-width: 1200px) {
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }
`;
export const Buttonspace = styled(Button)`
  @media (max-width: 417px) {
    margin-top:0.5rem !important; 
}
        & .rc-pagination-total-text{
          @media (max-width: 1050px) {
         display:none;
        }
`;
export const Boxspace = styled(Box)`
  @media (max-width: 470px) {
    gap: 1rem;
  }
`;
export const Boxedit = styled(Box)`
  @media (max-width: 996px) {
    display: flex;
    justify-content: flex-end;
  }
`;
